// The actions on an expense row, shared by the job's expense panel and the office
// expense list. Both screens list the same thing and must offer the same verbs; when
// they each built their own cell, a change to one silently left the other behind.
//
// "Mark as paid" appears only while the expense is unpaid: it is the one action whose
// whole purpose is to close that state, and on a paid row it would have nothing to do.
import he from '../i18n/he';
import Button from './Button';
import { isUnpaid } from '../utils/expenses';

export default function ExpenseActions({ expense, onMarkPaid, onEdit, onDelete }) {
  return (
    <div className="row">
      {isUnpaid(expense) && (
        <Button small variant="ghost" onClick={() => onMarkPaid(expense)}>
          {he.expenses.markPaid}
        </Button>
      )}
      <Button small variant="subtle" onClick={() => onEdit(expense)}>{he.common.edit}</Button>
      <Button small variant="subtle" onClick={() => onDelete(expense)}>{he.common.delete}</Button>
    </div>
  );
}
